// Line-by-line masked reveal for hero / section headings.
// CSS-driven (see .hero-reveal in index.css) so it paints on first render and
// does not depend on JS hydration — keeping LCP fast.
// The text stays in the normal DOM (no aria-label/aria-hidden) so the wrapping
// heading reads naturally for screen readers and AI agents.
export default function RevealText({ lines, className = "", delay = 0, stagger = 0.12 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <span className="block hero-reveal" style={{ animationDelay: `${delay + i * stagger}s` }}>
            {line}
            {i < lines.length - 1 ? " " : ""}
          </span>
        </span>
      ))}
    </span>
  );
}
